var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row gutter-sm q-mb-lg" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-6" },
        [
          _c(
            "p",
            { staticClass: "caption", staticStyle: { margin: "0" } },
            [
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(_vm.$t("minimum_score")) +
                  "\n\t\t\t\t\t"
              ),
              _c(
                "q-icon",
                {
                  staticClass: "q-ml-sm q-pb-sm",
                  attrs: {
                    name: "fal fa-question-circle",
                    size: "1.5rem",
                    color: "grey"
                  }
                },
                [
                  _c(
                    "q-tooltip",
                    {
                      staticClass: "custom-tooltip",
                      attrs: { anchor: "top left", self: "bottom right" }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.$t("minimum_score_info")) +
                          "\n\t\t\t\t\t"
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("q-input", {
            ref: "minimum_score",
            attrs: {
              type: "number",
              error: _vm.$v.minimum_score.$error,
              disable: _vm.has_answers
            },
            on: { input: _vm.$v.minimum_score.$touch },
            model: {
              value: _vm.minimum_score,
              callback: function($$v) {
                _vm.minimum_score = $$v
              },
              expression: "minimum_score"
            }
          }),
          _vm.$v.minimum_score.$error
            ? _c(
                "span",
                {
                  staticClass: "text-negative",
                  staticStyle: { display: "block", "margin-top": "5px" }
                },
                [_vm._v(_vm._s(_vm.$t("minimum_score_error")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-6" },
        [
          _c(
            "p",
            { staticClass: "caption", staticStyle: { margin: "0" } },
            [
              _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t("score")) + "\n\t\t\t\t\t"),
              _c(
                "q-icon",
                {
                  staticClass: "q-ml-sm q-pb-sm",
                  attrs: {
                    name: "fal fa-question-circle",
                    size: "1.5rem",
                    color: "grey"
                  }
                },
                [
                  _c(
                    "q-tooltip",
                    {
                      staticClass: "custom-tooltip",
                      attrs: { anchor: "top left", self: "bottom right" }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.$t("score_info")) +
                          "\n\t\t\t\t\t"
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("q-input", {
            ref: "score",
            attrs: {
              type: "number",
              error: _vm.$v.score.$error,
              disable: _vm.has_answers
            },
            on: { input: _vm.$v.score.$touch },
            model: {
              value: _vm.score,
              callback: function($$v) {
                _vm.score = $$v
              },
              expression: "score"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-6" },
        [
          _c("p", { staticClass: "caption", staticStyle: { margin: "0" } }, [
            _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t("timezone")) + "\n\t\t\t")
          ]),
          _c("q-select", {
            staticClass: "q-mt-sm",
            attrs: {
              options: _vm.timezones,
              filter: "",
              disable: _vm.has_answers
            },
            on: { input: _vm.changeTimezone },
            model: {
              value: _vm.timezone,
              callback: function($$v) {
                _vm.timezone = $$v
              },
              expression: "timezone"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-6" },
        [
          _c(
            "p",
            { staticClass: "caption", staticStyle: { margin: "0" } },
            [
              _vm._v(
                "\n\t\t\t\t\t" + _vm._s(_vm.$t("date_type")) + "\n\t\t\t\t"
              ),
              _c(
                "q-icon",
                {
                  staticClass: "q-ml-sm q-pb-sm",
                  attrs: {
                    name: "fal fa-question-circle",
                    size: "1.5rem",
                    color: "grey"
                  }
                },
                [
                  _c(
                    "q-tooltip",
                    {
                      staticClass: "custom-tooltip",
                      attrs: { anchor: "top left", self: "bottom right" }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.$t("date_type_info")) +
                          "\n\t\t\t\t\t"
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("q-select", {
            ref: "date_type",
            attrs: { options: _vm.date_type_list, disable: _vm.has_answers },
            model: {
              value: _vm.date_type,
              callback: function($$v) {
                _vm.date_type = $$v
              },
              expression: "date_type"
            }
          })
        ],
        1
      ),
      _vm.date_type === 2
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6" },
            [
              _c(
                "p",
                { staticClass: "caption", staticStyle: { margin: "0" } },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" + _vm._s(_vm.$t("weekdays")) + "\n\t\t\t\t\t"
                  ),
                  _c(
                    "q-icon",
                    {
                      staticClass: "q-ml-sm q-pb-sm",
                      attrs: {
                        name: "fal fa-question-circle",
                        size: "1.5rem",
                        color: "grey"
                      }
                    },
                    [
                      _c(
                        "q-tooltip",
                        {
                          staticClass: "custom-tooltip",
                          attrs: { anchor: "top left", self: "bottom right" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("weekdays_info")) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("q-select", {
                ref: "weekdays",
                attrs: {
                  multiple: "",
                  chips: "",
                  options: _vm.weekdays_list,
                  disable: _vm.has_answers
                },
                model: {
                  value: _vm.weekdays,
                  callback: function($$v) {
                    _vm.weekdays = $$v
                  },
                  expression: "weekdays"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.date_type === 1 || _vm.date_type === 2
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6" },
            [
              _c(
                "p",
                { staticClass: "caption", staticStyle: { margin: "0" } },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.$t("start_date")) +
                      "\n\t\t\t\t\t"
                  ),
                  _c(
                    "q-icon",
                    {
                      staticClass: "q-ml-sm q-pb-sm",
                      attrs: {
                        name: "fal fa-question-circle",
                        size: "1.5rem",
                        color: "grey"
                      }
                    },
                    [
                      _c(
                        "q-tooltip",
                        {
                          staticClass: "custom-tooltip",
                          attrs: { anchor: "top left", self: "bottom right" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("start_date_info")) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("q-datetime", {
                attrs: {
                  type: "date",
                  format: "DD/MM/YYYY",
                  clearable: "",
                  error: _vm.$v.start_date.$error,
                  disable: _vm.has_answers
                },
                model: {
                  value: _vm.start_date,
                  callback: function($$v) {
                    _vm.start_date = $$v
                  },
                  expression: "start_date"
                }
              }),
              _vm.$v.start_date.$error
                ? _c(
                    "span",
                    {
                      staticClass: "text-negative",
                      staticStyle: { display: "block", "margin-top": "5px" }
                    },
                    [_vm._v(_vm._s(_vm.$t("date_start_error")))]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.date_type === 1 || _vm.date_type === 2
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6 q-mb-sm" },
            [
              _c(
                "p",
                { staticClass: "caption", staticStyle: { margin: "0" } },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" + _vm._s(_vm.$t("end_date")) + "\n\t\t\t\t\t"
                  ),
                  _c(
                    "q-icon",
                    {
                      staticClass: "q-ml-sm q-pb-sm",
                      attrs: {
                        name: "fal fa-question-circle",
                        size: "1.5rem",
                        color: "grey"
                      }
                    },
                    [
                      _c(
                        "q-tooltip",
                        {
                          staticClass: "custom-tooltip",
                          attrs: { anchor: "top left", self: "bottom right" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("end_date_info")) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("q-datetime", {
                attrs: {
                  type: "date",
                  format: "DD/MM/YYYY",
                  clearable: "",
                  error: _vm.$v.end_date.$error,
                  disable: _vm.has_answers
                },
                model: {
                  value: _vm.end_date,
                  callback: function($$v) {
                    _vm.end_date = $$v
                  },
                  expression: "end_date"
                }
              }),
              _vm.$v.end_date.$error
                ? _c(
                    "span",
                    {
                      staticClass: "text-negative",
                      staticStyle: { display: "block", "margin-top": "5px" }
                    },
                    [_vm._v(_vm._s(_vm.$t("date_start_error")))]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.date_type === 3
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6" },
            [
              _c(
                "p",
                { staticClass: "caption", staticStyle: { margin: "0" } },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.$t("days_of_the_month")) +
                      "\n\t\t\t\t\t"
                  ),
                  _c(
                    "q-icon",
                    {
                      staticClass: "q-ml-sm q-pb-sm",
                      attrs: {
                        name: "fal fa-question-circle",
                        size: "1.5rem",
                        color: "grey"
                      }
                    },
                    [
                      _c(
                        "q-tooltip",
                        {
                          staticClass: "custom-tooltip",
                          attrs: { anchor: "top left", self: "bottom right" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("days_of_the_month_info")) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("q-select", {
                ref: "days_of_the_month",
                attrs: {
                  multiple: "",
                  clearable: "",
                  chips: "",
                  options: _vm.days_of_the_month_list,
                  error: _vm.$v.days_of_the_month.$error,
                  disable: _vm.has_answers
                },
                model: {
                  value: _vm.days_of_the_month,
                  callback: function($$v) {
                    _vm.days_of_the_month = $$v
                  },
                  expression: "days_of_the_month"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.date_type === 3
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6" },
            [
              _c(
                "p",
                { staticClass: "caption", staticStyle: { margin: "0" } },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.$t("start_month")) +
                      "\n\t\t\t\t\t"
                  ),
                  _c(
                    "q-icon",
                    {
                      staticClass: "q-ml-sm q-pb-sm",
                      attrs: {
                        name: "fal fa-question-circle",
                        size: "1.5rem",
                        color: "grey"
                      }
                    },
                    [
                      _c(
                        "q-tooltip",
                        {
                          staticClass: "custom-tooltip",
                          attrs: { anchor: "top left", self: "bottom right" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("start_month_info")) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("q-select", {
                ref: "start_month",
                attrs: {
                  options: _vm.months_list,
                  error: _vm.$v.start_month.$error,
                  disable: _vm.has_answers
                },
                model: {
                  value: _vm.start_month,
                  callback: function($$v) {
                    _vm.start_month = $$v
                  },
                  expression: "start_month"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.date_type === 3
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6" },
            [
              _c(
                "p",
                { staticClass: "caption", staticStyle: { margin: "0" } },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.$t("end_month")) +
                      "\n\t\t\t\t\t"
                  ),
                  _c(
                    "q-icon",
                    {
                      staticClass: "q-ml-sm q-pb-sm",
                      attrs: {
                        name: "fal fa-question-circle",
                        size: "1.5rem",
                        color: "grey"
                      }
                    },
                    [
                      _c(
                        "q-tooltip",
                        {
                          staticClass: "custom-tooltip",
                          attrs: { anchor: "top left", self: "bottom right" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("end_month_info")) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("q-select", {
                ref: "end_month",
                attrs: {
                  options: _vm.months_list,
                  error: _vm.$v.end_month.$error,
                  disable: _vm.has_answers
                },
                model: {
                  value: _vm.end_month,
                  callback: function($$v) {
                    _vm.end_month = $$v
                  },
                  expression: "end_month"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.date_type === 4
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6" },
            [
              _c(
                "p",
                { staticClass: "caption", staticStyle: { margin: "0" } },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.$t("custom_dates")) +
                      "\n\t\t\t\t\t"
                  ),
                  _c(
                    "q-icon",
                    {
                      staticClass: "q-ml-sm q-pb-sm",
                      attrs: {
                        name: "fal fa-question-circle",
                        size: "1.5rem",
                        color: "grey"
                      }
                    },
                    [
                      _c(
                        "q-tooltip",
                        {
                          staticClass: "custom-tooltip",
                          attrs: { anchor: "top left", self: "bottom right" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("custom_dates_info")) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("date-picker", {
                staticClass: "full-width",
                attrs: {
                  error: _vm.$v.custom_dates.$error,
                  lang: _vm.calendar_lang,
                  format: "DD/MM/YYYY",
                  id: "date-by-month",
                  multiple: "",
                  type: "date"
                },
                on: { input: _vm.$v.custom_dates.$touch },
                model: {
                  value: _vm.custom_dates,
                  callback: function($$v) {
                    _vm.custom_dates = $$v
                  },
                  expression: "custom_dates"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-6" },
        [
          _c(
            "p",
            { staticClass: "caption", staticStyle: { margin: "0" } },
            [
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(_vm.$t("show_feedback")) +
                  "\n\t\t\t\t\t"
              ),
              _c(
                "q-icon",
                {
                  staticClass: "q-ml-sm q-pb-sm",
                  attrs: {
                    name: "fal fa-question-circle",
                    size: "1.5rem",
                    color: "grey"
                  }
                },
                [
                  _c(
                    "q-tooltip",
                    {
                      staticClass: "custom-tooltip",
                      attrs: { anchor: "top left", self: "bottom right" }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.$t("show_feedback_info")) +
                          "\n\t\t\t\t\t"
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("q-select", {
            ref: "show_feedback",
            attrs: {
              options: _vm.show_feedback_list,
              disable: _vm.has_answers
            },
            model: {
              value: _vm.show_feedback,
              callback: function($$v) {
                _vm.show_feedback = $$v
              },
              expression: "show_feedback"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-6" },
        [
          _c(
            "p",
            { staticClass: "caption", staticStyle: { margin: "0" } },
            [
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(_vm.$t("allow_approved_to_answer")) +
                  "\n\t\t\t\t\t"
              ),
              _c(
                "q-icon",
                {
                  staticClass: "q-ml-sm q-pb-sm",
                  attrs: {
                    name: "fal fa-question-circle",
                    size: "1.5rem",
                    color: "grey"
                  }
                },
                [
                  _c(
                    "q-tooltip",
                    {
                      staticClass: "custom-tooltip",
                      attrs: { anchor: "top left", self: "bottom right" }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.$t("allow_approved_to_answer_info")) +
                          "\n\t\t\t\t\t"
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("q-select", {
            ref: "allow_approved_to_answer",
            attrs: {
              options: _vm.allow_approved_to_answer_list,
              disable: _vm.has_answers
            },
            model: {
              value: _vm.allow_approved_to_answer,
              callback: function($$v) {
                _vm.allow_approved_to_answer = $$v
              },
              expression: "allow_approved_to_answer"
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "col-12 row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c(
              "p",
              { staticClass: "caption", staticStyle: { margin: "0" } },
              [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.$t("qty_questions_frequency")) +
                    "\n\t\t\t\t\t"
                ),
                _c(
                  "q-icon",
                  {
                    staticClass: "q-ml-sm q-pb-sm",
                    attrs: {
                      name: "fal fa-question-circle",
                      size: "1.5rem",
                      color: "grey"
                    }
                  },
                  [
                    _c(
                      "q-tooltip",
                      {
                        staticClass: "custom-tooltip",
                        attrs: { anchor: "top left", self: "bottom right" }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("qty_questions_frequency_info")) +
                            "\n\t\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("q-input", {
              ref: "qty_questions_frequency",
              attrs: {
                type: "number",
                error: _vm.$v.qty_questions_frequency.$error,
                disable: _vm.has_answers
              },
              on: { input: _vm.$v.qty_questions_frequency.$touch },
              model: {
                value: _vm.qty_questions_frequency,
                callback: function($$v) {
                  _vm.qty_questions_frequency = $$v
                },
                expression: "qty_questions_frequency"
              }
            }),
            _vm.$v.qty_questions_frequency.$error
              ? _c(
                  "span",
                  {
                    staticClass: "text-negative",
                    staticStyle: { display: "block", "margin-top": "5px" }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("invalid_field")) +
                        "\n\t\t\t\t\t"
                    ),
                    _c(
                      "q-icon",
                      {
                        staticClass: "q-ml-sm q-pb-sm",
                        attrs: {
                          name: "fal fa-question-circle",
                          size: "1.5rem",
                          color: "red"
                        }
                      },
                      [
                        _c(
                          "q-tooltip",
                          {
                            staticClass: "custom-tooltip",
                            attrs: { anchor: "top left", self: "bottom right" }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t("qty_questions_frequency_error")
                                ) +
                                "\n\t\t\t\t\t\t"
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    ]),
    _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "tertiary",
              label: _vm.$t("back"),
              icon: "far fa-chevron-left"
            },
            on: {
              click: function($event) {
                return _vm.$router.push({ name: "admin_drills" })
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3" },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "negative",
              label: _vm.$t("unpublish"),
              icon: "far fa-ban"
            },
            on: {
              click: function($event) {
                return _vm.unpublish()
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "positive",
              disable: _vm.is_publish_disabled,
              label: _vm.$t("publish"),
              icon: "far fa-upload"
            },
            on: {
              click: function($event) {
                return _vm.publish()
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "secondary",
              label: _vm.$t("save"),
              icon: "far fa-save"
            },
            on: {
              click: function($event) {
                return _vm.saveData()
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }